import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 30px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	gap: 40px;
`;

export const SearchBar = styled.div`
	border-radius: 15px;
	border: 1px solid ${Colors.darkBlue};
	display: flex;
	flex-direction: column;
	gap: 16px;
	min-width: 900px;
	padding: 20px;
`;

export const Row = styled.div`
	display: flex;
	justify-content: left;
	flex-wrap: wrap;
	gap: 16px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: right;
	align-items: center;
	gap: 12px;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 14px;
	align-items: center;
`;

export const ScoreBadge = styled.span`
	display: inline-block;
	min-width: 56px;
	padding: 4px 8px;
	border-radius: 8px;
	text-align: center;
	font-weight: 700;
	color: white;
	background: ${(props) => props.$bg || Colors.darkBlue};
`;

export const CriticalBadge = styled.span`
	color: ${Colors.red};
	font-weight: 700;
`;

export const DetailSection = styled.div`
	margin-top: 18px;
	padding-top: 12px;
	border-top: 1px solid ${Colors.gray};
`;

export const DetailPopupContent = styled.div`
	width: min(960px, 92vw);
	max-width: 92vw;

	table.styled-table {
		width: 100%;
		table-layout: fixed;
		word-break: break-word;
	}

	table.styled-table td,
	table.styled-table th {
		overflow-wrap: anywhere;
	}
`;

export const DetailTitle = styled.h3`
	color: ${Colors.darkBlue};
	margin: 0 0 10px 0;
`;

export const CollapsibleHeader = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	color: ${Colors.darkBlue};
	font-size: 1.17em;
	font-weight: 700;
	text-align: left;

	&:hover {
		opacity: 0.85;
	}
`;

export const TranscriptionBox = styled.div`
	margin-top: 10px;
	max-height: 320px;
	overflow-y: auto;
	padding: 12px;
	border: 1px solid ${Colors.gray};
	border-radius: 8px;
	background: ${Colors.lightlightBlue2 || '#f5f8fa'};
	color: ${Colors.darkBlue};
	font-size: 14px;
	line-height: 1.5;
	white-space: pre-wrap;
	word-break: break-word;
`;

export const TranscriptionLang = styled.div`
	font-weight: 700;
	margin-bottom: 6px;
	text-transform: uppercase;
`;

export const MetaGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px 24px;
	margin-bottom: 12px;
`;

export const MetaItem = styled.div`
	color: ${Colors.darkBlue};
	font-size: 14px;

	strong {
		display: inline-block;
		min-width: 140px;
	}
`;

export const Evidence = styled.div`
	font-size: 13px;
	color: ${Colors.newGray};
	margin-top: 4px;
`;

export const List = styled.ul`
	margin: 8px 0 0 18px;
	padding: 0;
	color: ${Colors.darkBlue};
`;

export const ReviewActions = styled.div`
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	margin-top: 20px;
	flex-wrap: wrap;
`;

export const PaginationWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-top: 16px;
	color: ${Colors.darkBlue};
	flex-wrap: wrap;
`;

export const PaginationInfo = styled.span`
	font-size: 14px;
`;

export const PaginationButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const ReportCards = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
	gap: 16px;
	width: 100%;
	max-width: 1100px;
`;

export const ReportCard = styled.div`
	border: 1px solid ${Colors.darkBlue};
	border-radius: 12px;
	padding: 16px;
	background: ${Colors.lightlightBlue2};
	color: ${Colors.darkBlue};

	h4 {
		margin: 0 0 8px 0;
		font-weight: 600;
	}

	p {
		margin: 0;
		font-size: 28px;
		font-weight: 700;
	}
`;
